
import { title } from 'process';
import { element } from 'protractor';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Question, Survey } from '../shared/model-service';
import { PopupService } from '../shared/popup-service';
import { SurveyAnswerService } from '../../public-api';


@Component({
  selector: 'app-multiple-choices',
  templateUrl: './multiple-choices.component.html',
  styleUrls: ['./multiple-choices.component.css']
})
export class MultipleChoicesComponent {

  @Input() Question: Question;
  @Input() SurveyBase: Survey;

  questiondsIdLinks: number[] = [];
  questions: Question[] = [];
  result: Question;
  show: boolean = false;
  response: string = "";
  timer: any;
  selectedOptions;
  panelOpenState = true;

  popupService: PopupService

  constructor(private dialog: MatDialog, private surveyService: SurveyAnswerService) { }

  ngOnInit(): void {

    this.popupService = new PopupService(this.dialog);

    if (this.Question.result != "" && this.Question.result != null) {
      this.treatEditSurvey();
    } else {
      this.Question.result = "";
    }
  }

  sortBy(prop: string) {
    return this.Question.options.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
  }



  onNgModelChange($event) {

    if(this.timer != null ){
      clearTimeout(this.timer)
     }
   
     this.timer = setTimeout(() => {
       this.panelOpenState = false;
     }, 5000); 

     
    this.Question.options.forEach(option => {
      option.result = null
    });
    this.response = "";
    this.selectedOptions.forEach(element => {
      this.response = this.response + " / " + element.title

    });

    this.response = this.response.substring(this.response.indexOf("/") + 1);
    this.show = true
    this.questiondsIdLinks = [];
    this.questions = [];
    this.Question.result = "";
    $event.forEach(element => {
      this.Question.result = this.Question.result + "/" + element.title;
      
    
      element.result = element.title;


      if (this.Question?.options.find(x => x.id == element.id)?.links != null) {
        this.Question.options.find(x => x.id == element.id).result = "checked";

        this.Question.options.find(x => x.id == element.id).links.forEach(element => {
          element.questionDestinationId;
          this.questiondsIdLinks.push(element.questionDestinationId);
          /** Open popus */
          if (element.popupDestinationId != null) {
            this.popupService.openPopupDialog(element.popupDestinationId, this.SurveyBase);
          }

          /**open tip */
          if (element.tipDestinationTipId != null) {
            this.popupService.openTipDialog(element.tipDestinationTipId);
          }
        });

        this.questiondsIdLinks.forEach(element => {


          this.result = this.SurveyBase.questions.find(x => x.id == element);

          if (this.result != null && this.questions.indexOf(this.result) == -1) {
            this.questions.push(this.result);
          }
        })
      }
    });
    this.Question.result = this.Question.result.substring(this.Question.result.indexOf("/") + 1);
  }

  treatEditSurvey() {      
    this.panelOpenState = false;
    this.show = true;
      let arrayOption = this.Question.result.split('/', this.Question.result.length);
      arrayOption.forEach(optionResult => {
        if(optionResult){
          this.Question.options.forEach(option => {
            if(option.id.toString() === optionResult)
            {
              option.checked = true
         
            this.response = this.response + " / " + option.title;
    
            option.links.forEach(element => {
    
              element.questionDestinationId;
              this.questiondsIdLinks.push(element.questionDestinationId);
              /** Open popus */
              this.questiondsIdLinks.forEach(element => {
                this.result = this.SurveyBase.questions.find(x => x.id == element);
                if (this.result != null) {
    
                  this.questions.push(this.result);
                }
              })
            })
          }
        });
         

        }
      });  
 
    
    this.response = this.response.substring(this.response.indexOf("/") + 1);
  }

 
}
